<template>
  <v-container
    fluid
    :class="{ 'fullscreen': fullscreen, 'grey lighten-5': fullscreen }"
  >
    <v-row>
      <!-- Out of table toolbar -->
      <v-col
        cols="12"
        class="text-start text-md-end"
        v-if="showFullLayout && !hideExternalToolbar"
      >
        <v-btn
          text
          color="primary"
          @click="refreshData()"
        >
          <v-icon>mdi-refresh</v-icon> רענון
        </v-btn>

        <v-btn
          text
          color="primary"
          @click="initFilterStatus()"
        >
          <v-icon>mdi-minus-circle-outline</v-icon> נקה סינון
        </v-btn>

        <v-btn
          text
          color="primary"
          @click="multiSort = !multiSort"
        >
          <v-icon>mdi-sort-descending</v-icon> מיון מרובה {{ multiSort ? 'פועל' : 'כבוי' }}
        </v-btn>

        <v-menu
          v-model="columnsMenu"
          :close-on-content-click="false"
          :nudge-width="200"
          offset-y
        >
          <template v-slot:activator="{ on }">
            <v-btn
              text
              color="primary"
              v-on="on"
            >
              <v-icon>mdi-view-column</v-icon> עמודות טבלה
            </v-btn>
          </template>
          <v-card height="250px">
            <v-list>
              <v-list-item
                v-for="(header, index) of headers"
                :key="`header${index}`"
              >
                <v-list-item-action>
                  <v-checkbox
                    color="primary"
                    v-model="header.visible"
                  ></v-checkbox>
                </v-list-item-action>

                <v-list-item-content @click="header.visible = !header.visible">
                  <v-list-item-title>{{ header.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>

        <v-menu
          v-model="filterMenu"
          :close-on-content-click="false"
          :nudge-width="200"
          offset-y
        >
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              text
              color="primary"
            >
              <v-icon>mdi-filter-variant</v-icon> אפשרויות סינון
            </v-btn>
          </template>
          <v-card height="250px">
            <v-list>
              <v-list-item
                v-for="(filter, index) of filters"
                :key="`header${index}`"
              >
                <v-list-item-action>
                  <v-checkbox
                    color="primary"
                    v-model="filter.active"
                  ></v-checkbox>
                </v-list-item-action>

                <v-list-item-content @click="filter.active = !filter.active">
                  <v-list-item-title>{{ filter.label }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>

        <v-btn
          text
          color="primary"
          @click="fullscreen = !fullscreen"
        >
          <v-icon>{{ fullscreen ? 'mdi-fullscreen-exit' : 'mdi-fullscreen' }}</v-icon> מסך מלא
        </v-btn>

        <v-menu
          bottom
          right
        >
          <template v-slot:activator="{ on }">
            <v-btn
              text
              color="primary"
              v-on="on"
              :loading="exporting"
            >
              <v-icon>mdi-download</v-icon> ייצוא
            </v-btn>
          </template>

          <v-list>
            <v-list-item
              v-for="(item, i) in exportMenu"
              :key="i"
              @click="envokeMethodByName(item.click)"
            >
              <v-list-item-title>
                <v-icon v-if="item.icon">{{ item.icon }}</v-icon> {{ item.title }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

      </v-col>

      <!-- Table -->
      <v-col cols="12">
        <v-card>
          <v-data-table
            :multi-sort="multiSort"
            :must-sort="!multiSort"
            :headers="visibleHeaders"
            :items="items"
            item-key="_id"
            :options.sync="options"
            :server-items-length="totalItems"
            :loading="loading"
            :footer-props="{
              showFirstLastPage: true,
              itemsPerPageOptions
            }"
            class="elevation-0"
          >
            <template v-slot:top>
              <!-- Filters -->
              <v-row class="pl-4 pr-4">
                <v-col
                  :cols="!f.expanded ? '12' : false"
                  :md="!f.expanded ? '4' : false"
                  :lg="!f.expanded ? '2' : false"
                  v-for="(f, index) in activeFilters"
                  :key="`f${index}`"
                >
                  <!-- Text -->
                  <v-text-field
                    v-if="f.type === 'TEXT'"
                    v-model="filterStatus[f.model]"
                    :append-icon="f.icon"
                    :label="f.label"
                    height="42px"
                  ></v-text-field>

                  <!-- Date -->
                  <v-text-field
                    v-if="f.type === 'DATE'"
                    v-model="filterStatus[f.model]"
                    :append-icon="f.icon"
                    :label="f.label"
                    height="42px"
                    type="date"
                  ></v-text-field>

                  <!-- BOOLEAN -->
                  <v-checkbox
                    v-if="f.type === 'BOOLEAN'"
                    v-model="filterStatus[f.model]"
                    :append-icon="f.icon"
                    :label="f.label"
                    height="42px"
                    type="date"
                    color="primary"
                  ></v-checkbox>

                  <!-- Combobox -->
                  <v-autocomplete
                    v-if="f.type === 'COMBOBOX'"
                    :disabled="(f.dependsOn != undefined && filterStatus[f.dependsOn].length === 0)"
                    v-model="filterStatus[f.model]"
                    :items="getData(f.items)"
                    :item-text="f.itemText"
                    :item-value="f.itemValue"
                    :label="f.label"
                    multiple
                    chips
                    menu-props="right"
                    autocomplete="off"
                  >
                    <template
                      slot="selection"
                      slot-scope="{ item, index }"
                    >
                      <v-chip v-if="index <= 0">
                        <span>{{ item[f.itemText] }}</span>
                      </v-chip>
                      <span
                        v-if="index === 1"
                        class="grey--text caption"
                      >(+{{ filterStatus[f.model].length - 1 }})</span>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </template>

            <!-- Table Data -->
            <template v-slot:item="{ item }">
              <tr>
                <td
                  v-for="(header, index) in filteredHeaders"
                  :key="`td${index}`"
                >
                  <!-- Link -->
                  <template v-if="header.linkTo && header.linkTo(item)">
                    <template v-if="header.type === 'ICON'">
                      <v-btn
                        icon
                        small
                        :to="header.linkTo(item)"
                      >
                        <v-icon :color="header.getIcon(item).color">
                          {{ header.getIcon(item).icon }}
                        </v-icon>
                      </v-btn>
                    </template>
                    <template v-else>
                      <router-link :to="header.linkTo(item)">
                        {{ header.displayFunc(item, header.value) }}
                      </router-link>
                    </template>
                  </template>

                  <!-- No Link -->
                  <template v-else>
                    <template v-if="header.type === 'ICON'">
                      <v-icon :color="item.color">
                        {{ item.icon }}
                      </v-icon>
                    </template>
                    <template v-else-if="header.type === 'ACTION'">
                      <v-btn
                        text
                        icon
                        small
                        @click="doAction(header.click, item._id, header.name)"
                        :loading="actionLoaders[header.name + item._id]"
                      >
                        <v-icon
                          color="primary"
                          small
                        >{{ header.icon }}</v-icon>
                      </v-btn>
                    </template>
                    <template v-else-if="header.displayFunc">
                      {{ header.displayFunc(item, header.value) }}
                    </template>
                  </template>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Vue from "vue";
import { format } from "date-fns";
import { throttle } from "lodash";
import Mixins from "@/mixins/mixins";
import XLSX from "xlsx";

export default {
  data() {
    return {
      list: [],
      showFullLayout: true,
      fullscreen: false,
      columnsMenu: false,
      filterMenu: false,
      loading: true,
      actionLoaders: {},
      totalItems: 100000,
      multiSort: false,
      exportMenu: [
        {
          title: "קובץ Excel",
          icon: "mdi-file-excel",
          click: "exportToExcel"
        },
        {
          title: "קובץ CSV",
          icon: "mdi-file-document",
          click: "exportToCsv"
        }
      ],
      options: {},
      defaultOptions: {
        sortBy: this.sortBy,
        sortDesc: this.sortDesc,
        itemsPerPage: this.defaultItemsPerPage || 10,
        page: 1
      },
      itemsPerPageOptions: [5, 10, 50, { text: "הכל", value: -1 }],
      filterStatus: {},
      exporting: false
    };
  },
  computed: {
    activeFilters() {
      return this.filters.filter(item => {
        return item.active;
      });
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return this.isHeaderVisible(item.value);
      });
    },
    items() {
      return this.list.map(
        id => this.$store.state.entities[this.resource.entityType][id]
      );
    },
    visibleHeaders() {
      let headers = this.headers.filter(item => {
        return item.visible;
      });

      if (this.expand) {
        headers.push(this.expand);
      }

      return headers;
    }
  },
  beforeMount() {
    this.setPaginationFromUrl();
    this.initFilterStatus();
    this.setFilterStatusFromUrl();
    this.setLayoutFromUrl();
  },
  methods: {
    format,
    doAction(func, id, actionName) {
      Vue.set(this.actionLoaders, actionName + id, true);
      func(id)
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          Vue.set(this.actionLoaders, actionName + id, false);
        });
    },
    envokeMethodByName(name) {
      this[name]();
    },
    entityById(entityType, id) {
      return this.$store.getters["entity"](entityType, id);
    },
    getData(key) {
      return this.optionLists[key];
    },
    throttledGetDataFromApi: throttle(
      function(self) {
        self.getDataFromApi();
      },
      300,
      { leading: false, trailing: true, maxWait: 5000 }
    ),
    isHeaderVisible(value) {
      return this.headers.find(item => {
        return item.value === value;
      }).visible;
    },
    initFilterStatus() {
      for (let { type, model } of this.filters) {
        if (type === "COMBOBOX") {
          this.$set(this.filterStatus, model, []);
        } else {
          this.$set(this.filterStatus, model, null);
        }
      }
    },
    refreshData() {
      this.getDataFromApi();
    },
    generateParams() {
      return Object.assign(
        this.generateResourceSpecificParams(),
        this.generatePaginationParams(),
        { fullscreen: this.fullscreen },
        { showFullLayout: this.showFullLayout }
      );
    },
    generateResourceSpecificParams() {
      let params = {};
      for (let { type, model } of this.filters) {
        let filterStatus = this.filterStatus[model];
        if (filterStatus) {
          if (type === "DATE") {
            params[model] = format(filterStatus, "YYYY-MM-DD");
          } else if (type === "COMBOBOX") {
            if (filterStatus.length) {
              params[model] = filterStatus
                .map(item => {
                  return item._id ? item._id : item;
                })
                .reduce((prevValue, value) => prevValue + "," + value);
            }
          } else {
            params[model] = filterStatus;
          }
        }
      }
      return params;
    },
    generatePaginationParams() {
      let params = {};
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      let sortParam = null;
      let sortTempArray = [];
      if (
        sortBy &&
        Array.isArray(sortBy) &&
        sortDesc &&
        Array.isArray(sortDesc) &&
        sortBy.length === sortDesc.length
      ) {
        for (let i = 0; i < sortBy.length; ++i) {
          sortTempArray.push(`${sortDesc[i] ? "-" : ""}${sortBy[i]}`);
        }
        sortParam = sortTempArray.join(",");
      }

      if (page && itemsPerPage) {
        params.skip = (page - 1) * itemsPerPage;
        params.limit = itemsPerPage === -1 ? 0 : itemsPerPage;
      }

      if (sortParam) {
        params.sort = sortParam;
      }
      return params;
    },
    getDataFromApi() {
      this.loading = true;
      this.$store
        .dispatch("API_GET", {
          url: this.resource.endpoint,
          entityType: this.resource.entityType,
          schema: this.resource.listSchema,
          params: this.generateParams(),
          replace: true
        })
        .then(({ totalResults, list }) => {
          this.list = list;
          this.totalItems = totalResults;
        })
        .catch(err => {
          console.log(err);
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: err.message,
            color: "error"
          });
        })
        .finally(() => {
          this.loading = false;
          this.updateUrlQuery();
        });
    },
    updateUrlQuery() {
      if (this.doNotSaveState) {
        return;
      }
      let query = Object.assign(
        this.updateResourceSpecificUrlQuery(),
        this.updatePaginationUrlQuery(),
        { fullscreen: this.fullscreen }
      );
      this.$router.replace({ query });
    },
    updatePaginationUrlQuery() {
      let query = {};
      for (let key of Object.keys(this.options)) {
        let value = this.options[key];
        if (value && Array.isArray(value)) {
          query[key] = value.join(",");
        } else if (value) {
          query[key] = value;
        }
      }
      return query;
    },
    updateResourceSpecificUrlQuery() {
      let query = {};
      for (let { type, model } of this.filters) {
        let filterStatus = this.filterStatus[model];
        if (filterStatus) {
          if (type === "DATE") {
            query[model] = format(filterStatus, "YYYY-MM-DD");
          } else if (type === "COMBOBOX") {
            if (filterStatus.length) {
              query[model] = filterStatus
                .map(item => {
                  return item._id ? item._id : item;
                })
                .reduce((prevValue, value) => prevValue + "," + value);
            }
          } else {
            query[model] = filterStatus;
          }
        }
      }
      return query;
    },
    setFilterStatusFromUrl() {
      for (let filter of this.filters) {
        let value = this.$route.query[filter.model];
        if (value) {
          if (filter.type === "COMBOBOX") {
            let arr;
            if (Array.isArray(value)) {
              arr = value;
            } else {
              arr = value.split(",");
            }
            this.filterStatus[filter.model] = arr
              .map(item => {
                return this.optionLists[filter.model].find(item2 => {
                  return item2._id === item;
                });
              })
              .filter(item => {
                return item;
              });
          } else {
            this.filterStatus[filter.model] = value;
          }
          filter.active = true;
        }
      }
    },
    setPaginationFromUrl() {
      let newOptions = Object.assign({}, this.defaultOptions);
      let page = this.$route.query.page;
      if (page) {
        newOptions.page = parseInt(page) || 1;
      }

      let itemsPerPage = this.$route.query.itemsPerPage;
      if (itemsPerPage) {
        newOptions.itemsPerPage = parseInt(itemsPerPage) || 5;
      }

      let sortBy = this.$route.query.sortBy;
      if (sortBy) {
        newOptions.sortBy = sortBy.split(",");
      }

      let sortDesc = this.$route.query.sortDesc;
      if (sortDesc) {
        newOptions.sortDesc = sortDesc.split(",").map(item => {
          return item === "true" ? true : false;
        });
      }
      this.options = newOptions;
    },
    setLayoutFromUrl() {
      this.fullscreen = this.$route.query.fullscreen === "true";
      this.showFullLayout = this.$route.query.showFullLayout !== "false";
    },
    fetchReportData() {
      return new Promise((resolve, reject) => {
        let params = this.generateParams();
        params.skip = 0;
        params.limit = 0;
        this.$store
          .dispatch("API_GET", {
            url: this.resource.endpoint,
            entityType: this.resource.entityType,
            schema: this.resource.listSchema,
            params,
            replace: false
          })
          .then(({ list }) => {
            resolve(list);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    convertDataToTable(data) {
      let array = [];
      let headers = this.headers;
      for (let item of data) {
        let row = {};
        for (let header of headers) {
          if (header.displayFunc) {
            row[header.text] = header.displayFunc(item, header.value);
          }
        }
        array.push(row);
      }
      return array;
    },
    exportToExcel() {
      this.exportData({ type: "xlsx" });
    },
    exportToCsv() {
      this.exportData({ type: "csv" });
    },
    exportData({ type }) {
      this.exporting = true;
      this.fetchReportData()
        .then(list => {
          let data = list.map(
            id => this.$store.state.entities[this.resource.entityType][id]
          );
          let jsonTableData = this.convertDataToTable(data);
          var sheetData = XLSX.utils.json_to_sheet(jsonTableData);
          var wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, sheetData, "Data");
          XLSX.writeFile(wb, `${this.resource.endpoint}.${type}`);
        })
        .catch(err => {
          console.log(err);
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: err.response ? err.response.data.message : err.message,
            color: "error"
          });
        })
        .finally(() => {
          this.exporting = false;
        });
    },
    handleSocket(data) {
      if (data.modelName === this.resource.modelName) {
        this.refreshData();
      }
    }
  },

  sockets: {
    resource_created: function(data) {
      this.handleSocket(data);
    },
    resource_updated: function(data) {
      this.handleSocket(data);
    }
  },

  watch: {
    options: {
      handler() {
        this.getDataFromApi();
      },
      deep: true
    },
    filterStatus: {
      handler() {
        this.getDataFromApi();
      },
      deep: true
    },
    fullscreen: function() {
      this.updateUrlQuery();
    }
  },
  mounted() {
    if (this.itemsPerPageOptionsOverride) {
      this.itemsPerPageOptions = this.itemsPerPageOptionsOverride;
    }
  },
  props: [
    "headers",
    "filters",
    "sortBy",
    "sortDesc",
    "resource",
    "optionLists",
    "expand",
    "doNotSaveState",
    "hideExternalToolbar",
    "rowAction",
    "defaultItemsPerPage"
  ],
  mixins: [Mixins]
};
</script>

<style scoped>
.code-pre {
  word-break: break-word;
  white-space: pre-wrap;
}

.has-bottom-border {
  border-top: 1px #fff solid !important;
}
</style>
